module.exports = __webpack_public_path__ + "img/verseny-osztalyoknak.a618d4b9.jpg";